import zubg1 from "../../assets/images/zubg01.png";
import zubg2 from "../../assets/images/zubg02.png";
import zubg3 from "../../assets/images/zubg03.png";
import zubg4 from "../../assets/images/zubg04.png";
export const lawData = [
  {
    name: "最高人民法院、最高人民检察院、公安部关于依法处理信访活动中违法犯罪行为的指导意见",
    time: "2019-7-5",
    type: "opinion",
  },
  {
    name: "信访工作条例",
    time: "2022-02-25",
    type: "workClumn",
  },
  {
    name: "中华人民共和国劳动合同法",
    time: "2012-12-28",
    type: "labor",
  },
  {
    name: "中华人民共和国民法典",
    time: "2020-05-28",
    type: "civilCode",
  },
  {
    name: "中华人民共和国宪法",
    time: "2018-03-11",
    type: "constitution",
  },
  {
    name: "中华人民共和国刑法",
    time: "2009-08-27",
    type: "criminal",
  },
  {
    name: "中华人民共和国行政许可法",
    time: "2019-04-23",
    type: "administration",
  },
  {
    name: "中华人民共和国治安管理处罚法",
    time: "2012-10-26",
    type: "punish",
  },
];
export const policy = [
  {
    name: "国家信访局召开新闻通气会解读《依法分类处理信访诉求工作规则》",
    time: "2017-08-4",
  },
  {
    name: "国家信访局召开新闻通气会解读《信访工作责任制实施办法》",
    time: "2016-10-26",
  },
  {
    name: "国家信访局负责人就贯彻落实《信访事项办理群众满意度评价工作办法》答记者问",
    time: "2014-12-18",
  },
  {
    name: "国家信访局负责人就贯彻落实《国家信访局关于进一步加强初信初访办理工作的办法》答记者问",
    time: "2014-10-16",
  },
  {
    name: "中央政法委出台三个文件解决涉法涉诉信访突出问题",
    time: "2014-09-12",
  },
];
export const answer = [
  {
    name: "收到信访事项后，信访部门是如何处理的？",
    time: "",
    type: "handle",
  },
  {
    name: "信访事项的办理期限是如何规定的？",
    time: "",
    type: "regulations",
  },
  {
    name: "对处理意见不服怎么办？",
    time: "",
    type: "Disobedience",
  },
  {
    name: "对复查意见不服怎么办？",
    time: "",
    type: "review",
  },
  {
    name: "对复核意见不服，仍然以同一事实和理由提出投诉请求的，相关行政机关受理吗？",
    time: "",
    type: "repeat",
  },
  {
    name: "信访人在信访过程中，不得有哪些行为？",
    time: "",
    type: "prohibit",
  },
];
export const focusing = [
  {
    name: "国家信访局党组召开专题会议 迅速学习贯彻第九次全国信访工作会议精神",
    time: "2022-05-30",
    type: "huiyij",
  },
  {
    name: "李文章：加强和改进人民信访工作 全面履行为民解难为党分忧的政治责任",
    time: "2022-12-23",
    type: "zhengzrew",
  },
];
export const processData = [
  {
    name: "注册",
    type: "1",
    value: "按要求如实填写个人信息。",
    bgUrl: zubg1,
  },
  {
    name: "登录",
    type: "2",
    value: "通过姓名、证件号码或手机号码登录。",
    bgUrl: zubg2,
  },
  {
    name: "提交",
    type: "3",
    value: "通过  “投诉请求” 或 “建议征集” 窗口提交。",
    bgUrl: zubg3,
  },
  {
    name: "查询",
    type: "4",
    value: "查询提交事项的受理办理情况。",
    bgUrl: zubg4,
  },
];
